import {defaultSelectedDateFrom, defaultSelectedDateUp} from "./state";

export function setContacts(state, contacts){
    console.log(contacts)
    state.contacts = contacts
}

export function setInventoryReplacement(state, data){
    state.reportInventoryReplacement= data;
}
export function setInventoryReplacementDetail(state, data){
    state.reportInventoryReplacementDetail = data;
}





// WEBPACK FOOTER //
// ./src/modules/report-inventory-replacement/mutations.js